import { render, staticRenderFns } from "./CustomerInfoForm.vue?vue&type=template&id=d2dc1a1c&scoped=true"
import script from "./CustomerInfoForm.vue?vue&type=script&lang=ts"
export * from "./CustomerInfoForm.vue?vue&type=script&lang=ts"
import style0 from "./CustomerInfoForm.vue?vue&type=style&index=0&id=d2dc1a1c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2dc1a1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2dc1a1c')) {
      api.createRecord('d2dc1a1c', component.options)
    } else {
      api.reload('d2dc1a1c', component.options)
    }
    module.hot.accept("./CustomerInfoForm.vue?vue&type=template&id=d2dc1a1c&scoped=true", function () {
      api.rerender('d2dc1a1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/components/CustomerInfoForm.vue"
export default component.exports